import { useBrand } from "../contexts/BrandContext";

/**
 * Logo brand in cerchio con sfondo chiaro, pensato per i fondi scuri.
 * Il logo intero (simbolo + scritta) è centrato e limitato al quadrato inscritto
 * nel cerchio (~70% del diametro) con object-contain: nessun ingrandimento o
 * ritaglio, piccolo margine uniforme, proporzioni originali preservate.
 */
export function BrandLogoCircle({ className = "h-36 w-36", boxTestId, imgTestId }) {
  const { brand } = useBrand();
  return (
    <div
      className={`rounded-full shadow-lg flex items-center justify-center overflow-hidden ${className}`}
      style={{ background: "#F8EEF1" }}
      data-testid={boxTestId}
    >
      <img
        src={brand.logo_url}
        alt={brand.display_name}
        data-testid={imgTestId}
        width="480"
        height="442"
        decoding="async"
        className="max-w-[70%] max-h-[70%] w-auto h-auto object-contain"
        onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }}
      />
    </div>
  );
}
